import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {SIZE_PAGINATION} from "../../conf";
import {GenomeInterface} from "../interface/query/genome-interface";
import {postService} from "./serviceConsumption";
import {getRandomEcuadorianPhoneNumber} from "../../utils/numberOptions";
import {PaginationPersonTree} from "../interface/query/paginationPersonTree";
import {PersonTree} from "../interface/query/personTree";


export const findPersonGenome = async (data: SearchParamsInterface): Promise<GenomeInterface> => {
    return postService({
        service: `/information/genome`,
        data: {
            identifier: data.identifier
        }}
    ).then((response) => {
        const genome: GenomeInterface = response;
        // return genome;
        // TODO data test a eliminar cuando el backend este listo
        return {
            ...genome,
            phone: getRandomEcuadorianPhoneNumber(),
            ...(!!genome.personFather ? {
                personFather: {
                    ...genome.personFather,
                    phone: getRandomEcuadorianPhoneNumber()
                }
            } : {}),
            ...(!!genome.personMother ? {
                personMother: {
                    ...genome.personMother,
                    phone: getRandomEcuadorianPhoneNumber()
                }
            } : {}),
            siblingsPersons: genome.siblingsPersons?.map((person) => {
                return {
                    ...person,
                    phone: getRandomEcuadorianPhoneNumber()
                }
            })
        }
    })
}

export const useFindPersonGenome = (): UseMutationResult<GenomeInterface, Error, SearchParamsInterface> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonGenome(data),
    });
}

export const findFamilyTree = async (data: SearchParamsInterface): Promise<PaginationPersonTree> => {
    return postService({
        service: `/information/family/tree`,
        data: {
            identifier: data.identifier,
            page: data?.page,
            size: SIZE_PAGINATION
        }
    }).then((response) => {
        // return response;
        // TODO data test a eliminar cuando el backend este listo
        return {
            ...response,
            content: response?.content?.map((item: PersonTree) => ({
                ...item,
                personDto: {
                    ...item?.personDto,
                    phone: getRandomEcuadorianPhoneNumber()
                }
            }))
        }
    })
}

export const useFindFamilyTree = (): UseMutationResult<PaginationPersonTree, Error, SearchParamsInterface> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findFamilyTree(data),
    });
}
